export const GOOGLE_MAP_ADDRESS_TYPE = 'GOOGLE_MAP'
export const MASTER_DATA_ADDRESS_TYPE = 'MASTER_DATA'
export const DEFAULT_POINT_TYPE = 'DEFAULT'
export const START_POINT_TYPE = 'START'
export const END_POINT_TYPE = 'END'
export const PICKUP_ACTIVITY_TYPE = 'PICKUP'
export const DROP_ACTIVITY_TYPE = 'DROP'
